<template>
    <div class="BackHead" @click="BackHead">
        <div></div>
        <p>返回顶部</p>
    </div>
</template>
<script>
export default {
    name: 'top',
    data () {
        return {
            // logo:'static/images/logo.png',
        }
    },
    methods:{
        BackHead(){
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }
    },
    mounted(){
        $(window).scroll(function(){ 
            var srollPos = $(window).scrollTop();    //滚动条距顶部距离(页面超出窗口的高度) 
            var windowHeight=$(window).height();
            // var totalheight = parseFloat($(window).height()) + parseFloat(srollPos); 
            if(srollPos > windowHeight*1.5 ) {
                $('.BackHead').show();
            }else{
                $('.BackHead').hide();
            }
        });
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .BackHead{
        position: fixed;
        z-index: 9;
        width: 60px;
        height: 60px;
        bottom: 20%;
        right: 0;
        border-radius: 4px;
        background-color: #09ba79;
        display: none;
        cursor: pointer;
        &:hover{
            opacity: 0.8;
        }
        div{
            width: 20px;
            height: 20px;
            border: 2px solid #fff;
            border-left: 0;
            border-bottom: 0;
            transform:rotate(-45deg);
            margin: 0 auto;
            margin-top: 15px;
        }
        p{
            text-align: center;
            color: #fff;
            font-size: 12px;
        }
    }
    
</style>


// WEBPACK FOOTER //
// src/components/public/BackHead.vue